import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { Project } from 'app/modules/projects/projects.types';

@Component({
  selector: 'app-deals-with-same-properties',
  templateUrl: './deals-with-same-properties.component.html',
  styleUrls: ['./deals-with-same-properties.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DealsWithSamePropertiesComponent {
  addressMatches = [] as string[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { similarDeals: (Project & { matchedBy: string })[] },
    public matDialogRef: MatDialogRef<DealsWithSamePropertiesComponent>,
  ) {
    this.addressMatches = data.similarDeals.reduce((p, c) => {
      if (!p.includes(c.matchedBy)) {
        p.push(c.matchedBy);
      }

      return p;
    }, [] as string[]);
  }

  yes(): void {
    this.matDialogRef.close(true);
  }

  no(): void {
    this.matDialogRef.close(false);
  }
}
